import axios from "axios";
import { toast } from "sonner";
import {
  Image as ImageIcon, Upload, Trash2, Loader2, Globe, BarChart3,
} from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export function AfficheTab({ event, setEvent, headers, coverUploading, handleCoverUpload, handleCoverDelete }) {
  return (
    <div className="space-y-6" data-testid="affiche-tab">
      <div className="bg-[#0B0F19] border border-[#1E293B] rounded-xl p-6">
        <h3 className="text-white font-semibold flex items-center gap-2 mb-1"><ImageIcon className="h-4 w-4 text-[#F59E0B]" /> Affiche de l'evenement</h3>
        <p className="text-[#64748b] text-xs mb-6">Cette image sera affichee en haut de la page publique de l'evenement et dans les aperçus de partage.</p>

        {event.cover_image_url ? (
          <div className="space-y-4">
            <div className="relative rounded-xl overflow-hidden border border-[#2A3441] max-w-lg mx-auto">
              <img src={event.cover_image_url} alt="Affiche" className="w-full h-auto" data-testid="cover-preview" />
              <div className="absolute inset-0 bg-black/0 hover:bg-black/40 transition-all flex items-center justify-center opacity-0 hover:opacity-100">
                <div className="flex gap-2">
                  <label className="cursor-pointer bg-white/90 text-black px-3 py-1.5 rounded-lg text-sm font-medium flex items-center gap-1.5">
                    <Upload className="h-4 w-4" /> Remplacer
                    <input type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={handleCoverUpload} data-testid="cover-replace-input" />
                  </label>
                  <button onClick={handleCoverDelete} className="bg-red-500/90 text-white px-3 py-1.5 rounded-lg text-sm font-medium flex items-center gap-1.5" data-testid="cover-delete-btn">
                    <Trash2 className="h-4 w-4" /> Supprimer
                  </button>
                </div>
              </div>
            </div>
            <p className="text-[#64748b] text-xs text-center">Survolez l'image pour la remplacer ou la supprimer.</p>
          </div>
        ) : (
          <label className="cursor-pointer block" data-testid="cover-upload-zone">
            <div className="border-2 border-dashed border-[#2A3441] rounded-xl p-12 text-center hover:border-[#F59E0B]/50 transition-colors">
              {coverUploading ? (
                <Loader2 className="h-10 w-10 text-[#F59E0B] animate-spin mx-auto" />
              ) : (
                <>
                  <Upload className="h-10 w-10 text-[#2A3441] mx-auto mb-4" />
                  <p className="text-white font-medium">Cliquez pour telecharger une affiche</p>
                  <p className="text-[#64748b] text-xs mt-1">JPG, PNG ou WebP — Max 10 Mo</p>
                </>
              )}
            </div>
            <input type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={handleCoverUpload} data-testid="cover-upload-input" />
          </label>
        )}
      </div>

      {/* Public visibility setting */}
      <div className="bg-[#0B0F19] border border-[#1E293B] rounded-xl p-6">
        <h3 className="text-white font-semibold flex items-center gap-2 mb-3"><Globe className="h-4 w-4 text-[#0099CC]" /> Visibilite</h3>
        <label className="flex items-center gap-3 cursor-pointer">
          <input type="checkbox" checked={event.is_public_listed !== false}
            onChange={async (e) => {
              try {
                await axios.patch(`${API}/api/event/events/${event.id}`, { is_public_listed: e.target.checked }, { headers });
                setEvent(prev => ({ ...prev, is_public_listed: e.target.checked }));
                toast.success(e.target.checked ? "Visible dans l'annuaire" : "Retire de l'annuaire");
              } catch { toast.error("Erreur"); }
            }}
            className="h-5 w-5 rounded accent-[#0099CC]" data-testid="public-listed-toggle" />
          <div>
            <p className="text-white text-sm font-medium">Visible dans l'annuaire public</p>
            <p className="text-[#64748b] text-xs">Si desactive, l'evenement ne sera accessible que par son lien direct.</p>
          </div>
        </label>
      </div>

      {/* Public stats toggle */}
      <div className="bg-[#0B0F19] border border-[#1E293B] rounded-xl p-6">
        <h3 className="text-white font-semibold flex items-center gap-2 mb-3"><BarChart3 className="h-4 w-4 text-[#8B5CF6]" /> Statistiques publiques</h3>
        <label className="flex items-center gap-3 cursor-pointer">
          <input type="checkbox" checked={event.show_public_stats === true}
            onChange={async (e) => {
              try {
                await axios.patch(`${API}/api/event/events/${event.id}`, { show_public_stats: e.target.checked }, { headers });
                setEvent(prev => ({ ...prev, show_public_stats: e.target.checked }));
                toast.success(e.target.checked ? "Statistiques visibles publiquement" : "Statistiques masquees");
              } catch { toast.error("Erreur"); }
            }}
            className="h-5 w-5 rounded accent-[#8B5CF6]" data-testid="public-stats-toggle" />
          <div>
            <p className="text-white text-sm font-medium">Afficher publiquement le nombre d'inscrits</p>
            <p className="text-[#64748b] text-xs">Si active, les visiteurs verront le nombre de participants inscrits sur la page publique.</p>
          </div>
        </label>
      </div>
    </div>
  );
}
